import React, { useState, useRef } from "react";
import "../../../stylesheet/prescription.css";
import '../../../stylesheet/activities.css'
import { FiEdit2 } from "react-icons/fi";
import { useNavigate } from "react-router";
import { editPatient } from "../../../Utils/localStore";

const DetailSummary = ({ details, notify, modifyPatient }) => {
  const navigate = useNavigate()
  const [showStatusEdit, setShowStatusEdit] = useState(false)
  const statusDialog = useRef(null)
  const editPatientStatus = async () => {
    details.status = details.status === 'Active' ? 'InActive' : 'Active'
    await editPatient(details)
      .then(resp => {
        notify.success('Status changed successfully', { position: notify.POSITION.TOP_CENTER })
        modifyPatient(details)
      })
      .catch(error => {
        notify.error('Something went wrong, please try again later', { position: notify.POSITION.TOP_CENTER })
        throw new Error(error)
      })
    setShowStatusEdit(false)
  }
  return (
    <>
      {
        showStatusEdit &&
        <dialog ref={statusDialog} open={showStatusEdit}>
          <div className="w-[300px] bg-white rounded-md p-8 border">
            <p className="text-center mb-6">Are you sure you want to change the status of this record?</p>
            <div className="flex justify-between">
              <button onClick={(e) => {
                e.preventDefault()
                editPatientStatus()
              }} className="rounded-md text-white bg-primary p-2">
                Confirm
              </button>
              <button autoFocus className="p-2" onClick={(e) => {
                e.preventDefault()
                setShowStatusEdit(false)
              }}>
                Cancel
              </button>
            </div>
          </div>
        </dialog>
      }
      {
        !details ? <p className="w-full text-center italic">
          No records to display </p>
          :
          <section className="font-euclid-circular-a mt-2">
            <div className="border border-gray-500 w-fit">
              <div className="detail_table">
                <h2 className="font-semibold">Patient Details</h2>

                <button onClick={(e) => {
                  e.preventDefault()
                  localStorage.setItem('patientEditMode', true)
                  navigate('/patients/new-patient')
                }}>
                  <FiEdit2 />
                </button>
              </div>
              <div className="detail_table">
                <span>Gender</span>
                <span>{details.gender || '-'}</span>
              </div>
              <div className="detail_table">
                <span>Age</span>
                <span>{details.age || '-'}</span>
              </div>
              <div className="detail_table">
                <span>Phone Number</span>
                <span>{details.contactDetails || '-'} </span>
              </div>
              <div className="detail_table">
                <span>Location</span>
                <span className="text-right">{details.address || '-'} </span>
              </div>
              <div className="detail_table">
                <span>Number of Visits</span>
                <span>{'-'}</span>
              </div>
              <div className="detail_table">
                <span>Value</span>
                <span>&#8358; {'-'}</span>
              </div>
              <div className="detail_table">
                <span>Intake date</span>
                <span>{details.joinedDate || '-'}</span>
              </div>
              <div className="detail_table">
                <span className="text-left" >Status</span>
                <div className="status">
                  <span className={`stats ${details.status} text-right ml-1`}>{details.status}</span>
                  <button onClick={(e) => {
                    e.preventDefault()
                    setShowStatusEdit(true)
                  }} className="ml-2">
                    <FiEdit2 />
                  </button>
                </div>
              </div>
              <div className="detail_table">
                <span>Patient Summary</span>
                <button onClick={(e) => {
                  e.preventDefault()
                  localStorage.setItem('patientEditMode', true)
                  navigate('/patients/new-patient?position=summary')
                }}>
                  <span className="flex gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M19 7.00001L19 1.00001M19 1.00001H13M19 1.00001L10 10M8 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V12"
                        stroke="#4B4B4B"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>{" "}
                    View
                  </span>
                </button>
              </div>
            </div>

            <div className="mt-12 font-euclid-circular-a leading-7">
              <div className="next_appt">
                <div className="next_appt_items">
                  <p className="text-zinc-800 text-opacity-80 text-lg font-semibold leading-7 tracking-wide">
                    Next appointment
                  </p>
                  <button onClick={(e) => {
                    e.preventDefault()
                    // localStorage.setItem('patientEditMode', true)
                    // naviga
                  }}>
                    <FiEdit2 />
                  </button>
                </div>
                <div className="next_appt_items">
                  <p>February 10, 2023</p>
                  <p>9:00 AM -10:00 AM</p>
                </div>
                <p>Radiology ward</p>
                <p>Dr. Salam Adekogbe</p>
              </div>
            </div>
          </section>
      }
    </>
  );
};

export default DetailSummary;
